import { Procedence } from '../Model/Procedence';
export class ProcedencesService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(procedenceId) {
        if (procedenceId) {
            const response = await this.apiService.get('proccedencesDestinatary/' + procedenceId);
            if (!response.ok) {
                throw new Error(`Error al obtener el parámetro.`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ProcedenceId.`);
        }
    }
    async find() {
        const response = await this.apiService.get('procedencesDestinatary');
        if (!response.ok) {
            throw new Error(`Error al obtener las procedencias.`);
        }
        const content = await response.json();
        return content.map(procedence => new Procedence(procedence).getState());
    }
    async findDiferentTypes() {
        const response = await this.apiService.get('diferent_types');
        if (!response.ok) {
            throw new Error(`Error al obtener las procedencias.`);
        }
        return await response.json();
    }
    async saveProcedence(procedence) {
        if (procedence) {
            const response = await this.apiService.post('procedence', procedence);
            if (!response.ok) {
                throw new Error(`Error al guardar el procedenceetro.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener procedence.`);
        }
    }
    async removeprocedence(procedence) {
        if (procedence) {
            const response = await this.apiService.post('procedence/remove', procedence);
            if (!response.ok) {
                throw new Error(`Error al eliminar el procedenceetro.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener procedence.`);
        }
    }
}
